import React from "react";
import { motion } from "framer-motion";

export const LogoMark = ({ className = "" }) => (
  <svg viewBox="0 0 44 44" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="a3grad" x1="4" y1="4" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0066FF" />
        <stop offset="1" stopColor="#00F0FF" />
      </linearGradient>
    </defs>
    {/* connections forming an "A" */}
    <path d="M22 8 L9 36 M22 8 L35 36 M14.5 23 H29.5" stroke="url(#a3grad)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    {/* signal arcs off the apex node */}
    <path d="M27.5 6.5 a6 6 0 0 1 4.2 4.2" stroke="#00F0FF" strokeWidth="1.6" strokeLinecap="round" opacity="0.9" />
    <path d="M29.5 3.5 a10 10 0 0 1 7 7" stroke="#00F0FF" strokeWidth="1.4" strokeLinecap="round" opacity="0.5" />
    {/* three nodes = "3" / A3 */}
    <circle cx="22" cy="8" r="4" fill="#00F0FF" />
    <circle cx="22" cy="8" r="7" stroke="#00F0FF" strokeWidth="1" opacity="0.35" />
    <circle cx="9" cy="36" r="3.6" fill="#0066FF" />
    <circle cx="35" cy="36" r="3.6" fill="#0066FF" />
  </svg>
);

export const Logo = ({ className = "", size = "h-9 w-9" }) => (
  <div className={`flex items-center gap-3 select-none ${className}`} data-testid="site-logo">
    <LogoMark className={`${size} shrink-0`} />
    <div className="leading-none hidden sm:block">
      <span className="font-display font-extrabold text-[16px] tracking-tight text-white">
        A3<span className="text-cyan" style={{ color: "#00F0FF" }}>NETWORKS</span>
      </span>
      <span className="block mono-label text-[9px] mt-0.5" style={{ color: "#64748B" }}>
        Telecom Infrastructure
      </span>
    </div>
  </div>
);

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, num }) => (
  <div className="flex items-center gap-4 mb-6">
    {num && <span className="mono-label text-cyan">{num}</span>}
    <span className="h-px w-8 bg-white/20" />
    <span className="mono-label" style={{ color: "#94A3B8" }}>{children}</span>
  </div>
);
